import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "min-h-screen px-4 text-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "inline-block h-screen align-middle",
  "aria-hidden": "true"
}, "​", -1)
const _hoisted_3 = { class: "inline-block w-full max-w-xl p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-white dark:bg-app-gray-700 shadow rounded-md" }
const _hoisted_4 = { class: "mt-5" }
const _hoisted_5 = { class: "mb-4" }
const _hoisted_6 = { class: "mb-6" }
const _hoisted_7 = {
  key: 0,
  class: "text-app-error dark:text-app-red-400 text-xs"
}
const _hoisted_8 = { class: "grid grid-cols-2 gap-3 mt-3" }

import { Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot } from "@headlessui/vue";
import { Button, TextField } from "@toruslabs/vue-components";
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";

import ControllersModule from "@/modules/controllers";

import SelectField from "./SelectField.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ImportAccount',
  props: {
    isOpen: { type: Boolean, default: false },
    importAccountError: { default: "" }
  },
  emits: ["onClose", "onConfirm"],
  setup(__props: any, { emit: emits }) {

const { t } = useI18n();
const importTypes = [
  {
    label: t("accountMenu.privateKey"),
    value: "private",
  },
];

const importType = ref(importTypes[0]);
const importKey = ref("");




const closeModal = () => {
  emits("onClose");
};

const confirmImport = () => {
  emits("onConfirm", importKey.value);
};

const isDarkMode = computed(() => {
  return ControllersModule.isDarkMode;
});

const refDiv = ref(null);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TransitionRoot), {
    appear: "",
    show: _ctx.isOpen,
    as: "template"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Dialog), {
        open: _ctx.isOpen,
        class: _normalizeClass({ dark: isDarkMode.value }),
        "initial-focus": refDiv.value,
        as: "div"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            ref_key: "refDiv",
            ref: refDiv,
            class: "fixed inset-0 z-10 overflow-y-auto"
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_unref(DialogOverlay), { class: "fixed inset-0 opacity-30 bg-gray-200 dark:bg-gray-500" }),
              _hoisted_2,
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "duration-300 ease-out",
                "enter-from": "opacity-0 scale-95",
                "enter-to": "opacity-100 scale-100",
                leave: "duration-200 ease-in",
                "leave-from": "opacity-100 scale-100",
                "leave-to": "opacity-0 scale-95"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_unref(DialogTitle), {
                      as: "h3",
                      class: "text-lg font-bold leading-6 text-app-text-500 dark:text-app-text-dark-400 focus-within:outline-none",
                      tabindex: "0"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)("accountMenu.importedAccount")), 1)
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(SelectField, {
                          modelValue: importType.value,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((importType).value = $event)),
                          label: _unref(t)('accountMenu.selectImportType'),
                          items: importTypes
                        }, null, 8, ["modelValue", "label"])
                      ]),
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_unref(TextField), {
                          modelValue: importKey.value,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((importKey).value = $event)),
                          type: "password",
                          label: "Input Private Key:"
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    (!!_ctx.importAccountError)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.importAccountError), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", null, [
                        _createVNode(_unref(Button), {
                          block: true,
                          variant: "tertiary",
                          onClick: closeModal
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Close")
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", null, [
                        _createVNode(_unref(Button), {
                          block: true,
                          variant: "primary",
                          onClick: confirmImport
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Confirm")
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ]),
                _: 1
              })
            ])
          ], 512)
        ]),
        _: 1
      }, 8, ["open", "class", "initial-focus"])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})